
	import Modal from '@/components/Modal.vue';
	import ShoeSizePicker from '@/components/ShoeSizePicker.vue';
	import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
	import { packs } from '@/store/ProductStore';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: { ShoeSizePicker, Modal }
	})
	export default class TimeoutError extends Vue {
		close() {
			this.$emit('close');
		}

		async endSession() {
			await this.$router.push('index');
			location.reload();

			this.close();
		}
	}
